import restApiConnection from '@/services/api/providers/Connection'
import userSessionResponse from '@/types/responses/userSessionResponse'
import RestApiBase from '@/services/models/RestApiBase'
import store from '@/services/store'
import { CACHE_TTL_DEFAULT, USER_SESSION_API_URL } from '@/config'

export default class UserSession extends RestApiBase {
  public static async get(): Promise<userSessionResponse | undefined> {
    return this.sync('GetUserSession', this.getOwn)
  }

  public static getOwn = async (): Promise<userSessionResponse | undefined> => {
    if (!restApiConnection.defaults?.headers?.common?.Authorization)
      return Promise.reject()

    try {
      const selectedOffice = store.getters.plainSelectedOperationOffice
      const data = await restApiConnection.get(USER_SESSION_API_URL, {
        params: selectedOffice
          ? {
              operation_office_id: selectedOffice.id,
            }
          : undefined,
        cache: {
          ttl: CACHE_TTL_DEFAULT,
        },
      })
      return data
    } catch (error) {
      console.error('API Call Failed on UserSession. Error:', error)
      throw error
    }
  }

  public static getStoredUserId(): string | null {
    const user_session = store.getters.plainUserSession
    return user_session?.user_session_id || null
  }
}
